import { ref, Ref } from "vue";

export class EbToggle {
	public toggled: Ref<boolean> = ref(false);
}